<template>
  <v-container class="pa-0">
    <v-container class="wrapper pa-3">
      <v-container class="d-flex justify-start pa-0 gap-2">
        <v-btn color="primary" outlined @click="openPanelDialog('add')">
          <span>{{ $t("add-new-panel") }}</span>
          <v-icon size="16" class="mr-1">mdi-plus</v-icon>
        </v-btn>
        <v-btn color="secondary" outlined @click="visitGuideLink">
          <span class="ml-1">{{ $t("Panel connection tutorial") }}</span>
          <my-icon :name="'exclamation-mark-icon'" :width="16" :height="16" />
        </v-btn>
      </v-container>
      <v-container class="pa-0 mt-5 columns">
        <v-container
          class="pa-4 column-panel d-flex justify-space-between align-center mt-2"
          v-for="(item, index) in items"
          :key="index"
        >
          <div class="d-flex align-center gap-3">
            <v-card-text class="pa-0 text-caption">{{ index + 1 }}</v-card-text>
            <v-card-text class="pa-0 text-body-2">{{
              item.panel_name != null ? item.panel_name : $t("processing-panel")
            }}</v-card-text>
          </div>
          <div class="d-flex align-center gap-5">
            <v-card-text
              class="pa-0 text-body-2"
              :style="{ color: item.panel_status == 'active' ? '#137333' : '#ff5252' }"
            >
              {{ $t(item.panel_status) }}
            </v-card-text>
            <v-btn
              outlined
              color="primary"
              height="32"
              @click="openSyncPermission(item, index)"
              :disabled="syncingPanels.includes(index)"
            >
              {{
                syncingPanels.includes(index)
                  ? $t("synchronizing-products") + "..."
                  : $t("synchronize-products")
              }}
            </v-btn>
            <v-btn
              outlined
              color="primary"
              height="32"
              :disabled="item.panel_status != 'active'"
              @click="syncOrders(item)"
            >
              {{ $t("Synchronizing-orders") }}
            </v-btn>
            <div @click="openPanelDialog('edit', item)">
              <my-icon
                :name="'edit-icon'"
                :width="16"
                :height="17"
                :stroke="'#000'"
                :cursor-pointer="true"
              />
            </div>
          </div>
        </v-container>
        <v-container class="d-flex justify-space-between pa-0 mt-10">
          <v-btn color="primary" height="32" @click="submit" :loading="loading">
            {{ $t("submit") }}
          </v-btn>
          <v-btn color="secondary" height="32" outlined>
            {{ $t("cancel") }}
          </v-btn>
        </v-container>
      </v-container>
    </v-container>
    <v-dialog
      v-model="panelDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      max-width="800"
    >
      <v-card class="pa-5">
        <v-form ref="form" v-model="valid">
          <v-container class="pa-0 d-flex justify-space-between align-center">
            <v-card-text class="pa-0 text-body-1">
              {{
                dialogType == "add"
                  ? $t("add-new-panel")
                  : $t("edit-panel") +
                    " " +
                    (selectedEditItem && selectedEditItem.panel_name != null
                      ? selectedEditItem.panel_name
                      : " ")
              }}
            </v-card-text>
            <v-icon size="20" @click="panelDialog = false">mdi-close</v-icon>
          </v-container>
          <v-card-text class="pa-0 text-body-2 mt-7 mb-4">{{
            $t("general-setting")
          }}</v-card-text>
          <v-container class="pa-0 d-flex gap-2">
            <!--<v-text-field
              v-model="newPanel.panel_name"
              :label="$t('panel-title')"
              outlined
              height="32"
              dense
              style="width: 45px;"
              :rules="[v => !!v || $t('is-required')]"
            />-->
            <v-container class="wrapper-toggle d-flex pa-0 ma-0" style="width: 151px">
              <div
                v-for="(item, index) in activatorOptions"
                :key="index"
                @click="selectStatusPanel(item)"
                class="child flex-fill text-center"
                :style="{
                  'background-color': selectedStatusPanel == item.value ? '#E5FEED' : '',
                  'border-color':
                    selectedStatusPanel == item.value ? '#0066ff' : 'silver',
                  color: selectedStatusPanel == item.value ? '#137333' : '',
                }"
              >
                <v-card-text class="pa-0 text-caption">{{ item.label }}</v-card-text>
              </div>
            </v-container>
            <!-- <v-text-field
              v-if="newPanel && newPanel.configs"
              v-model="newPanel.configs.digikala_token"
              :label="$t('apiKey')"
              outlined
              height="32"
              dense
              :rules="[v => !!v || $t('is-required')]"
            /> -->
          </v-container>
          <v-container class="pa-0 d-flex align-center gap-2 mt-5 mb-9">
            <v-text-field
              v-if="newPanel && newPanel.configs"
              v-model="newPanel.phone"
              :label="$t('digikala-mobile-panel')"
              outlined
              height="32"
              dense
              :rules="[(v) => !!v || $t('is-required')]"
            />
            <v-text-field
              v-if="newPanel && newPanel.configs"
              v-model="newPanel.configs.currency_coefficient"
              :label="$t('currency_coefficient')"
              outlined
              height="32"
              dense
              :rules="[(v) => !!v || $t('is-required')]"
              type="number"
            />
          </v-container>
          <v-card-text class="pa-0 text-body-2 mt-5 mb-2">{{
            $t("return-invoices")
          }}</v-card-text>
          <v-container class="d-flex gap-3 pa-0">
            <v-card-text class="pa-0 text-body-2 mt-2">{{
              $t("Select the desired option to register returned invoices")
            }}</v-card-text>
            <v-container
              class="wrapper-toggle d-flex align-center pa-0 ma-0"
              style="width: 200px"
            >
              <div
                v-for="(item, index) in invoiceOptions"
                :key="index"
                @click="selectInvoiceOption(item)"
                class="child flex-fill text-center"
                :style="{
                  'background-color':
                    selectedInvoiceOption == item.value ? '#D9EEFF' : '',
                  'border-color':
                    selectedInvoiceOption == item.value ? '#0066ff' : 'silver',
                  color: selectedInvoiceOption == item.value ? '#0066FF' : '',
                }"
              >
                <v-card-text class="pa-0 text-caption">{{ item.label }}</v-card-text>
              </div>
            </v-container>
          </v-container>
          <v-card-text class="pa-0 text-body-2 mt-5 mb-2"></v-card-text>

          <v-container class="d-flex align-center gap-3 pa-0 mb-7">
            <v-card-text class="pa-0 text-body-2">{{
              $t("inventory-update")
            }}</v-card-text>
            <v-container
              class="wrapper-toggle d-flex align-center pa-0 ma-0"
              style="width: 150px"
            >
              <div
                v-for="(item, index) in activatorOptions"
                :key="index"
                @click="selectStatusInventoryUpdate(item)"
                class="child flex-fill text-center"
                :style="{
                  'background-color':
                    selectedStatusInventoryUpdate == item.value ? '#E5FEED' : '',
                  'border-color':
                    selectedStatusInventoryUpdate == item.value ? '#0066ff' : 'silver',
                  color: selectedStatusInventoryUpdate == item.value ? '#137333' : '',
                }"
              >
                <v-card-text class="pa-0 text-caption">{{ item.label }}</v-card-text>
              </div>
            </v-container>
            <v-card-text class="pa-0 text-body-2">{{
              $t("fixed-price-update")
            }}</v-card-text>
            <v-container
              class="wrapper-toggle d-flex align-center pa-0 ma-0"
              style="width: 150px"
            >
              <div
                v-for="(item, index) in activatorOptions"
                :key="index"
                @click="selectStatusPriceUpdate(item)"
                class="child flex-fill text-center"
                :style="{
                  'background-color':
                    selectedStatusPriceUpdate == item.value ? '#E5FEED' : '',
                  'border-color':
                    selectedStatusPriceUpdate == item.value ? '#0066ff' : 'silver',
                  color: selectedStatusPriceUpdate == item.value ? '#137333' : '',
                }"
              >
                <v-card-text class="pa-0 text-caption">{{ item.label }}</v-card-text>
              </div>
            </v-container>
          </v-container>
          <v-card-text class="pa-0 text-body-2 mt-1 mb-4">{{
            $t("entrepotToUse")
          }}</v-card-text>

          <autocomplete
            v-model="newPanel.configs.seller_warehouse"
            :rules="[(v) => !!v || $t('is-required')]"
            :title="$t('Choosing a warehouse with the seller')"
            type="entrepot"
            style="width: 266px"
          />
          <v-card-text class="pa-0 text-body-2 mt-9 mb-5">{{
            $t("Warehouses that are created for this panel")
          }}</v-card-text>
          <autocomplete
            v-if="newPanel && newPanel.configs"
            v-model="newPanel.configs.digikala_warehouse"
            :rules="[(v) => !!v || $t('is-required')]"
            :title="$t('Warehouse near Digikala? (Panel title)')"
            type="entrepot"
            style="width: 266px"
          />
          <autocomplete
            v-if="newPanel && newPanel.configs"
            v-model="newPanel.configs.returns_digikala_warehouse"
            :rules="[(v) => !!v || $t('is-required')]"
            :title="$t('Return warehouse of digital goods? (Panel title)')"
            type="entrepot"
            style="width: 266px"
            class="mt-9"
          />
          <v-container class="pa-0 ma-0 mt-8 align-center" style="width: 277px">
            <v-card-text class="pa-0 text-body-2 mt-1 mb-4">{{
              $t("order_history_starts_at")
            }}</v-card-text>
            <template>
              <template v-if="newPanel && newPanel.configs">
                <v-text-field
                  id="startDateId"
                  v-model="newPanel.configs.order_history_starts_at"
                  :rules="[(v) => !!v || $t('is-required')]"
                  :label="$t('date')"
                  outlined
                  dense
                  height="32"
                  clearable
                  readonly
                  hide-details="auto"
                  class="rtl-text w-100 pl-3"
                />

                <date-picker
                  v-model="newPanel.configs.order_history_starts_at"
                  element="startDateId"
                  type="datetime"
                  compact-time
                  :locale="$store.state.date_locale"
                  :format="dateTimeFormat"
                  auto-submit
                  :color="
                    $vuetify.theme.themes[$vuetify.theme.isDark ? 'dark' : 'light']
                      .primary
                  "
                />
              </template>
            </template>
          </v-container>

          <v-container class="pa-0 d-flex align-center justify-space-between mt-10">
            <div class="d-flex align-center gap-1">
              <v-btn
                color="primary"
                height="32"
                @click="checkValidation"
                :loading="loading"
              >
                {{ dialogType == "add" ? $t("confirm") : $t("edit") }}
              </v-btn>
              <v-btn color="secondary" outlined height="32" @click="panelDialog = false">
                {{ $t("cancel") }}
              </v-btn>
            </div>
            <v-btn color="error" outlined height="32" @click="openDeletePanel">
              <span class="ml-1">{{ $t("delete-panel") }}</span>
              <my-icon
                :name="'trash-icon'"
                :width="15"
                :height="15"
                :cursor-pointer="true"
                :fill="'#ff5252'"
              />
            </v-btn>
          </v-container>
        </v-form>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="deleteDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      max-width="350"
    >
      <v-card class="pa-5">
        <v-card-text class="pa-0 text-body-2">
          {{ $t("Are you sure you want to delete this item ?") }}
        </v-card-text>
        <v-container class="pa-0 d-flex align-center gap-2 mt-6">
          <v-btn color="error" height="32" @click="deletePanel" :loading="loading">
            {{ $t("yes") }}
          </v-btn>
          <v-btn color="secondary" height="32" outlined @click="deleteDialog = false">
            {{ $t("no") }}
          </v-btn>
        </v-container>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="productSyncPermission"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      max-width="350"
    >
      <v-card class="pa-5">
        <v-container class="pa-0 d-flex justify-space-between align-center">
          <v-card-text class="pa-0 text-body-2">{{
            $t("receive product information from digikala")
          }}</v-card-text>
          <v-icon size="20" @click="productSyncPermission = false">mdi-close</v-icon>
        </v-container>
        <v-card-text class="pa-0 text-body-2 my-8" style="line-height: 25px">
          {{ $t("do you want to sync the panel product information ?") }}
          <br />
          {{ panelName }}
          <br />
          {{ $t("are you sure ?") }}
        </v-card-text>
        <v-container class="pa-0 d-flex gap-2">
          <v-btn color="primary" height="32" @click="synchronization">
            {{ $t("yes, synchronize") }}
          </v-btn>
          <v-btn
            color="secondary"
            outlined
            height="32"
            @click="productSyncPermission = false"
          >
            {{ $t("cancel") }}
          </v-btn>
        </v-container>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="productSync"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      max-width="350"
    >
      <v-card class="pa-5">
        <v-container class="pa-0 d-flex justify-space-between align-center">
          <v-card-text class="pa-0 text-body-2">{{
            $t("receive product information from digikala")
          }}</v-card-text>
          <v-icon size="20" @click="productSync = false">mdi-close</v-icon>
        </v-container>
        <v-container class="pa-0 d-flex justify-center align-center my-5">
          <img src="@/assets/integrators/sync-digikala.png" />
        </v-container>
        <v-container class="pa-0 d-flex justify-center align-center">
          <v-card-text class="pa-0 text-body-2 text-center" style="line-height: 25px">
            {{ $t("we are syncing panel product information") }}
            {{ panelName }}
            {{ $t("from digikala") }}
            {{ $t("this process may take time. Please be patient.") }}
          </v-card-text>
        </v-container>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="syncSuccessDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      max-width="350"
    >
      <v-card class="pa-5">
        <v-container class="pa-0 d-flex justify-space-between align-center">
          <v-card-text class="pa-0 text-body-2">{{
            $t("receive product information from digikala")
          }}</v-card-text>
          <v-icon size="20" @click="syncSuccessDialog = false">mdi-close</v-icon>
        </v-container>
        <v-container class="pa-0 d-flex justify-center align-center my-7">
          <img v-if="isUserGaveAccess" src="@/assets/integrators/sync-success.png" />
          <img v-else src="@/assets/integrators/sync-failed.png" />
        </v-container>
        <v-container class="pa-0 d-flex justify-center align-center">
          <v-card-text class="pa-0 text-body-2">
            {{
              isUserGaveAccess
                ? $t("your connection has been established successfully.")
                : $t(
                    "unfortunately your connection has not been established successfully."
                  )
            }}
          </v-card-text>
        </v-container>
      </v-card>
    </v-dialog>
    <v-snackbar
      v-model="snakbar"
      :color="snakbarColor ? snakbarColor : ''"
      top
      style="z-index: 1000000000000 !important"
    >
      {{ snakbarText }}

      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="snakbar = !snakbar">
          {{ $t("close") }}
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
import MyIcon from "../../components/general/icon/MyIcon.vue";

export default {
  data() {
    return {
      panelDialog: false,
      selectedStatusPanel: null,
      selectedInvoiceOption: null,
      selectedStatusInventoryUpdate: null,
      selectedStatusPriceUpdate: null,
      snakbar: false,
      snakbarText: null,
      snakbarColor: null,
      dialogType: null,
      valid: true,
      selectedIndex: null,
      deleteDialog: false,
      items: [],
      userInfo: null,
      loading: false,
      newPanel: {
        id: null,
        type: "digikala",
        phone: null,
        abr_name: this.userInfo?.init?.abrName,
        abr_token: this.userInfo?.token,
        panel_name: null,
        panel_status: null,
        configs: Object.assign(
          {},
          {
            currency_coefficient: null,
            return_invoices_status: null,
            inventory_update: null,
            price_update: null,
            seller_warehouse: null,
            digikala_warehouse: null,
            returns_digikala_warehouse: null,
            order_history_starts_at: null,
          }
        ),
      },
      productSyncPermission: false,
      panelName: null,
      productSync: null,
      selectedSyncPanel: null,
      syncingPanels: [],
      syncSuccessDialog: false,
      isUserGaveAccess: false,
      wantedSyncPanel: null,
      panelId: null,
      selectedEditItem: null,
      syncOrderResult: null,
    };
  },
  methods: {
    fetchPanelList() {
      var app = this;
      app.$axios
        .get(this.$apipoint + "config/digikala/list")
        .then((r) => {
          this.items = r.data;
        })
        .catch((err) => {
          this.serverErrorHandeler(err);
        });
    },
    openPanelDialog(type, selectedItem) {
      this.panelDialog = true;
      if (type == "add") {
        this.newPanel.configs.currency_coefficient = 1;
        // consider toggle buttons default (show)
        this.selectedStatusPanel = "active";
        this.selectedInvoiceOption = "register";
        this.selectedStatusInventoryUpdate = "active";
        this.selectedStatusPriceUpdate = "active";
        // insert defaults in objects
        this.newPanel.panel_status = this.selectedStatusPanel;
        this.newPanel.configs.return_invoices_status = this.selectedInvoiceOption;
        this.newPanel.configs.inventory_update = this.selectedStatusInventoryUpdate;
        this.newPanel.configs.price_update = this.selectedStatusPriceUpdate;

        this.dialogType = "add";
      }
      if (type == "edit" && selectedItem) {
        this.dialogType = "edit";
        this.newPanel = {
          id: selectedItem.id,
          type: "digikala",
          phone: selectedItem.phone,
          abr_name: this.userInfo?.init?.abrName,
          abr_token: this.userInfo?.token,
          panel_name: selectedItem.panel_name,
          panel_status: selectedItem.panel_status,
          configs: {
            currency_coefficient: selectedItem.configs.currency_coefficient,
            return_invoices_status: selectedItem.configs.return_invoices_status,
            inventory_update: selectedItem.configs.inventory_update,
            price_update: selectedItem.configs.price_update,
            seller_warehouse: selectedItem.configs.seller_warehouse,
            digikala_warehouse: selectedItem.configs.digikala_warehouse,
            returns_digikala_warehouse: selectedItem.configs.returns_digikala_warehouse,
            order_history_starts_at: selectedItem.configs.order_history_starts_at,
          },
        };
        this.selectedStatusPanel = selectedItem.panel_status;
        this.selectedInvoiceOption = selectedItem.configs.return_invoices_status;
        this.selectedStatusInventoryUpdate = selectedItem.configs.inventory_update;
        this.selectedStatusPriceUpdate = selectedItem.configs.price_update;

        this.selectedEditItem = selectedItem;
        this.selectedIndex = this.items.findIndex(
          (item) =>
            item.panel_name == selectedItem.panel_name &&
            item.panel_status == selectedItem.panel_status
        );
        /* console.log('selected index ' + this.selectedIndex) */
      }
    },
    selectStatusPanel(item) {
      this.selectedStatusPanel = item.value;
      this.newPanel.panel_status = this.selectedStatusPanel;
    },
    selectInvoiceOption(item) {
      this.selectedInvoiceOption = item.value;
      this.newPanel.configs.return_invoices_status = this.selectedInvoiceOption;
    },
    selectStatusInventoryUpdate(item) {
      this.selectedStatusInventoryUpdate = item.value;
      this.newPanel.configs.inventory_update = this.selectedStatusInventoryUpdate;
    },
    selectStatusPriceUpdate(item) {
      this.selectedStatusPriceUpdate = item.value;
      this.newPanel.configs.price_update = this.selectedStatusPriceUpdate;
    },
    checkValidation() {
      if (this.$refs.form.validate() && this.dialogType == "add") {
        this.submitSinglePanel();
      }
      if (this.$refs.form.validate() && this.dialogType == "edit") {
        this.editPanel();
      }
    },
    submitSinglePanel() {
      this.loading = true;
      var app = this;
      app.$axios
        .post(this.$apipoint + "config/digikala/store", [this.newPanel])
        .then((r) => {
          this.loading = false;
          this.snakbarText = this.$t("new panel successfully added");
          this.snakbarColor = "green";
          this.snakbar = true;
          this.panelId = r.data.panel.id;
          this.visitLink(r.data.panel.panel_token);
        })
        .catch((err) => {
          this.serverErrorHandeler(err);
        });
    },
    addPanel() {
      // const sameObject = this.items.some(item => item.configs.digikala_token == this.newPanel.configs.digikala_token)
      // if (!sameObject) {
      // add columns (show)
      // this.items.push(this.newPanel)
      // this.panelDialog = false
      /* console.log('items after add' + JSON.stringify(this.items)) */
      // } else {
      // this.snakbarText = this.$t('duplicate digikala token')
      // this.snakbarColor = 'red'
      // this.snakbar = true
      // }
      this.items.push(this.newPanel);
      this.panelDialog = false;
    },
    editPanel() {
      // edit column (show)
      this.items.splice(this.selectedIndex, 1, this.newPanel);
      this.panelDialog = false;
      /* console.log('items after edit' + JSON.stringify(this.items)) */
    },
    openDeletePanel() {
      if (this.dialogType == "add") {
        this.panelDialog = false;
      }
      if (this.dialogType == "edit") {
        this.deleteDialog = true;
      }
    },
    submit() {
      // post api
      this.loading = true;
      var app = this;
      app.$axios
        .post(this.$apipoint + "config/digikala/store", this.items)
        .then((r) => {
          this.loading = false;
          this.snakbarText = this.$t("new panel successfully added");
          this.snakbarColor = "green";
          this.snakbar = true;
        })
        .catch((err) => {
          this.serverErrorHandeler(err);
        });
    },
    deletePanel() {
      // delete api
      this.loading = true;
      const id = this.items[this.selectedIndex].id;
      /* console.log(id) */
      if (id != null) {
        var app = this;
        app.$axios
          .delete(this.$apipoint + `config/destroy/${id}`)
          .then((r) => {
            if (r.data.status == "success") {
              this.loading = false;
              this.items.splice(this.selectedIndex, 1);
              this.deleteDialog = false;
              this.panelDialog = false;
              this.snakbarText = this.$t("your panel removed successfully");
              this.snakbarColor = "red";
              this.snakbar = true;
            }
          })
          .catch((err) => {
            this.serverErrorHandeler(err);
          });
      } else {
        this.loading = false;
        this.items.splice(this.selectedIndex, 1);
        this.panelDialog = false;
        this.deleteDialog = false;
        this.snakbarText = this.$t("your panel removed successfully");
        this.snakbarColor = "red";
        this.snakbar = true;
      }
    },
    openSyncPermission(item, index) {
      var app = this;
      app.$axios
        .get(this.$apipoint + "config/digikala/list")
        .then((r) => {
          this.items = r.data;
          this.wantedSyncPanel = this.items.find(
            (obj) =>
              obj.panel_name == item.panel_name && obj.panel_status == item.panel_status
          );
          console.log(this.wantedSyncPanel.panel_token);
        })
        .catch((err) => {
          this.serverErrorHandeler(err);
        });
      this.productSyncPermission = true;
      this.panelName = item.panel_name;
      this.selectedSyncPanel = index;
    },
    synchronization() {
      // call api
      this.pullingProduct();
      this.productSyncPermission = false;
      this.productSync = true;

      if (!this.syncingPanels.includes(this.selectedSyncPanel)) {
        this.syncingPanels.push(this.selectedSyncPanel);
      }
    },
    pullingProduct() {
      var app = this;
      app.$axios
        .post("https://integrator.abriron.com/api/" + "products/digikala/pulling", {
          panel_token: this.wantedSyncPanel.panel_token,
        })
        .then((r) => {
          console.log(r.data);
        })
        .catch((err) => {
          this.serverErrorHandeler(err);
        });
    },
    visitLink(value) {
      const url = `https://seller.digikala.com/pwa/seller-services/consents?client_code=WPdl2XpBf7oabmVoOlVI&redirect_url=https://integrator.abriron.com/api/digikala/auth/callback&scopes=order%20variant%20profile%20product%20inventory%20insight%20growth_coach%20question%20package%20shipment%20sbs_setting%20sbs_orders%20sbs_shipment&state=${value}`;
      const features =
        "width=800,height=600,top=100,left=200,resizable=yes,scrollbars=yes";
      const digikalaWindow = window.open(url, "_blank", features);

      const app = this;
      let callCount = 0;
      const maxAttempts = 200;

      const fetchAuthStatus = () => {
        callCount++;

        app.$axios
          .post("https://integrator.abriron.com/api/config/check-auth", {
            panel_token: value,
          })
          .then((r) => {
            if (r.data.message) {
              digikalaWindow.close();
              clearInterval(authInterval);
              clearInterval(checkWindowClosed);

              this.panelDialog = false;
              this.addPanel();
              this.syncSuccessDialog = true;
              this.isUserGaveAccess = true;
            } else if (callCount >= maxAttempts) {
              digikalaWindow.close();
              clearInterval(authInterval);
              clearInterval(checkWindowClosed);

              /* this.fetchPanelList() */

              this.panelDialog = false;
              this.syncSuccessDialog = true;
              this.isUserGaveAccess = false;

              var app = this;
              app.$axios
                .delete(this.$apipoint + `config/destroy/${this.panelId}`)
                .then((r) => {})
                .catch((err) => {
                  this.serverErrorHandeler(err);
                });
            } else {
              // console.log(`Attempt ${callCount}: waiting for user to authorize...`)
            }
          })
          .catch((err) => {
            app.serverErrorHandeler(err);
          });
      };

      const authInterval = setInterval(fetchAuthStatus, 3000);
      fetchAuthStatus();

      const checkWindowClosed = setInterval(() => {
        if (digikalaWindow.closed) {
          clearInterval(authInterval);
          clearInterval(checkWindowClosed);
        }
      }, 1000);
    },
    visitGuideLink() {
      const url =
        "https://abriron.com/%d8%a7%d8%aa%d8%b5%d8%a7%d9%84-%d8%af%db%8c%d8%ac%db%8c%da%a9%d8%a7%d9%84%d8%a7-%d8%a8%d9%87-%d8%a7%d8%a8%d8%b1%d8%a2%db%8c%d8%b1%d9%88%d9%86/";
      const newTab = window.open(url, "_blank");
      if (newTab) {
        newTab.focus();
      }
    },
    syncOrders(item) {
      var app = this;
      app.$axios
        .post("https://integrator.abriron.com/api/" + "digikala/resend-order", {
          token: item.panel_token,
        })
        .then((r) => {
          app.snakbar = true;
          app.snakbarText = this.$t(r.data.message);
          app.snakbarColor = "red";
        })
        .catch((err) => {
          this.serverErrorHandeler(err);
        });
    },
  },
  mounted() {
    this.fetchPanelList();
    this.userInfo = JSON.parse(localStorage.getItem("token"));
  },
  computed: {
    dateTimeFormat() {
      return this.$store.state.date_locale === "fa,en"
        ? "jYYYY/jMM/jDD HH:mm"
        : "YYYY/MM/DD HH:mm";
    },
    activatorOptions() {
      return [
        { label: this.$t("active"), value: "active" },
        { label: this.$t("deactive"), value: "deactive" },
      ];
    },
    invoiceOptions() {
      return [
        { label: this.$t("registration-of-returned-invoice"), value: "register" },
        { label: this.$t("delete-invoice"), value: "delete" },
      ];
    },
  },
  watch: {
    panelDialog(val) {
      if (!val) {
        // reset keys
        this.newPanel = {
          id: null,
          type: "digikala",
          phone: null,
          abr_name: this.userInfo?.init?.abrName,
          abr_token: this.userInfo?.token,
          panel_name: null,
          panel_status: null,
          configs: {
            currency_coefficient: null,
            return_invoices_status: null,
            inventory_update: null,
            price_update: null,
            seller_warehouse: null,
            digikala_warehouse: null,
            returns_digikala_warehouse: null,
            order_history_starts_at: null,
          },
        };
        // reset form
        this.$refs.form.reset();
        // reset toggle button
        this.selectedStatusPanel = null;
        this.selectedInvoiceOption = null;
        this.selectedStatusInventoryUpdate = null;
        this.selectedStatusPriceUpdate = null;

        this.newPanel.panel_status = null;
        this.newPanel.configs.return_invoices_status = null;
        this.newPanel.configs.inventory_update = null;
        this.newPanel.configs.price_update = null;
      }
    },
    userInfo: {
      handler(val) {
        if (val?.init) {
          this.newPanel.abr_name = val.init.abrName || null;
          this.newPanel.abr_token = val.token || null;
        }
      },
      deep: true,
      immediate: true,
    },
  },
  components: {
    MyIcon,
  },
};
</script>

<style scoped>
.wrapper {
  background-color: #fcfcfc;
}
.wrapper .columns .column-panel {
  border: 1px solid silver;
  border-radius: 4px;
}
.v-card__text {
  width: auto;
}
.wrapper-toggle {
  border: 1px solid silver;
  border-radius: 4px;
}
.wrapper-toggle .child {
  padding: 7.7px;
  cursor: pointer;
  border-radius: 4px;
}
.wrapper-toggle .child:first-child {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.wrapper-toggle .child:nth-child(2) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
</style>
